<template>
    <div>
        <nav class="">
            <section class="page-header profile_page">
                <div class="container">
                    <div class="page-header_wrap">
                        <div class="page-heading">
                            <h1>Propuesta - 
                                {{item.titulo}}
                            </h1>
                        </div>
                        <ul class="coustom-breadcrumb">
                            <li>
                                <a href="#"
                                    ><i class="fa fa-user-circle"></i> {{item.cliente.nombre}}</a
                                >
                            </li>
                            <li><small>Canal: </small> {{item.canal}} - <small>Origen: </small> {{item.origen}}</li>
                            <li>DATA</li>
                        </ul>
                        <button 
                        data-toggle="modal"
                        data-target="#modalAgendar"
                        class="btn float-right">Agenda tu Cita</button>
                    </div>
                </div>
            </section>
        </nav>
        <section class="listing-detail">
            <div class="container">
                <div class="row">
                    <div class="col-md-8">
                        <listaImagenes 
                        :fotos="fotosData" />
                        <div class="listing_more_info">
                            <tabListingContainer />
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-12">
                        <ofertaNegocio />
                        <comentarioAsesor />
                        <div class="sidebar_widget" v-if="Object.keys(opcionesList).length > 0">
                            <div class="widget_heading">
                                <h5>
                                    <i class="fa fa-car" aria-hidden="true"></i>
                                    Más Opciones
                                </h5>
                            </div>
                            <listaVehiculosConseguir/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <modalAgendar />
    </div>
</template>

<script>
import modalAgendar from "components/agendar/modalAgendar";
import listaImagenes from "../detalleVehiculo/frontListaImagenes";
import tabListingContainer from "../detalleVehiculo/tabs/tabListingContainer";
import ofertaNegocio from "./frontOfertaNegocio";
import comentarioAsesor from "./frontComentarioAsesor";
import listaVehiculosConseguir from "./frontListaConseguir";
import {UPDATE_PROPUESTA} from 'store/store-constants';
import moment from 'moment';
import {mapFields} from "vuex-map-fields";
export default {
    props: {
        prospecto: {
            type: Object 
        }
    },
    data() {
        return {
            item: {
                titulo: "Titulo",
                cliente: {
                    nombre: "Nombre cliente"
                },
                canal: "Canal",
                origen: "Origen",
            },
            fotosData: [
                'inventario/610417ff8552bc45a317a8a2/fotos/NhoiweIY0BUtnQvoXnTKYBulOYGa1NwaLsHO3OSr.jpeg',
                'inventario/610417ff8552bc45a317a8a2/fotos/NhoiweIY0BUtnQvoXnTKYBulOYGa1NwaLsHO3OSr.jpeg',
                'inventario/610417ff8552bc45a317a8a2/fotos/NhoiweIY0BUtnQvoXnTKYBulOYGa1NwaLsHO3OSr.jpeg',
                'inventario/610417ff8552bc45a317a8a2/fotos/NhoiweIY0BUtnQvoXnTKYBulOYGa1NwaLsHO3OSr.jpeg',
                'inventario/610417ff8552bc45a317a8a2/fotos/NhoiweIY0BUtnQvoXnTKYBulOYGa1NwaLsHO3OSr.jpeg'
            ],
            opcionesList: [
                "",
                "",
                "",
                "",
                ""
            ]
        }
    },
    components: {
        listaImagenes,
        tabListingContainer,
        ofertaNegocio,
        comentarioAsesor,
        listaVehiculosConseguir,
        modalAgendar
    },
    mounted () {
        this.$store.commit(UPDATE_PROPUESTA, this.prospecto);
        this.vehiculo = this.prospecto.inventario;
    },
    computed: {
        ...mapFields('fichaTecnica', [
            'vehiculo',
        ]),
        inventarioData() {
            return this.$store.state.propuesta.inventario; 
        },
        clienteData() {
            return this.$store.state.propuesta.clientes; 
        },
        basicoData() {
            return this.$store.state.propuesta.basico; 
        },
        createDate() {
            return this.$store.state.propuesta.create_at; 
        }
    },
    methods: {
        format_create_date: (date) => {
            return moment(date).format('DD-MM-YYYY');
        },
        openAgendar(){
            this.$root.$emit( "bv::toggle::modal", "modalAgendar", "#agendar-btn" );
        }
    },
};
</script>

<style lang="scss">
.page-header {
    background-color: #000000;
    background-repeat: no-repeat;
    box-shadow: 1px 3px 2px 0px #a5a2a2;
    background-size: cover;
    background-position: center;
    border: 0 none;
    margin: 0 auto;
    padding: 0;
    position: relative;
}
.profile_page {
    background-image: none;
}
span.span-td {
    font-size: 10px;
    color: #828282;
}
</style>
